import { ArrowUpRight } from "lucide-react";
import { fmt, ddmmyyyy, isZero } from "@/lib/format";

export const LinkedSettlements = ({ rows, onOpen }) => (
  <section className="border border-amber-400 bg-amber-50" data-testid="linked-settlements">
    <div className="flex items-center justify-between gap-2 px-4 py-2.5 border-b border-amber-300">
      <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-amber-900">SETTLEMENT rows from the daily sheet</p>
      <button data-testid="linked-open-daily-btn" onClick={onOpen} className="text-xs font-semibold text-amber-900 flex items-center gap-1 hover:underline">
        Open daily <ArrowUpRight size={13} />
      </button>
    </div>
    {rows.length === 0 ? (
      <p className="px-4 py-4 text-sm text-amber-900/70" data-testid="linked-empty">No settlement rows in the daily sheet for this range.</p>
    ) : (
      <div className="ledger-scroll overflow-x-auto">
        <table className="w-max min-w-full text-sm">
          <thead>
            <tr className="text-[10px] uppercase tracking-[0.12em] text-amber-900/80">
              {["Date", "Withdrawal", "Deposit", "Total Balance", "Available Bal", "Difference", "Note"].map((h) => (
                <th key={h} className={`px-4 py-2 font-bold ${h === "Date" || h === "Note" ? "text-left" : "text-right"}`}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-amber-200" data-testid="linked-settlement-row">
                <td className="px-4 py-2 font-mono font-semibold">{ddmmyyyy(r.date)}</td>
                <td className="px-4 py-2 text-right font-mono tabular-nums">{fmt(r.withdrawal)}</td>
                <td className="px-4 py-2 text-right font-mono tabular-nums">{fmt(r.deposit)}</td>
                <td className="px-4 py-2 text-right font-mono tabular-nums font-semibold">{fmt(r.total)}</td>
                <td className="px-4 py-2 text-right font-mono tabular-nums font-semibold">{fmt(r.available_bal)}</td>
                <td className={`px-4 py-2 text-right font-mono tabular-nums font-semibold ${isZero(r.pnl) ? "text-green-700" : "text-red-700"}`}>{fmt(r.pnl)}</td>
                <td className="px-4 py-2">{r.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);
